import React, { FC, useEffect } from "react";
import useGlobalModel from "../../model/globalModel";
import { useHistory } from "react-router-dom";
import "./Login.scss";
import { defaultMdCmParam, CLIENT_APP_CODE } from "@/utils/constants";
import { loginServiceAuth2, Auth2MenuDetail } from "./LoginServiceAuth2";
import "./config";

interface ITokenLogin {
	token: string;
}
declare const window: Window & { loginTimer: NodeJS.Timeout | null };

export const TokenLogin: FC<ITokenLogin> = ({ token }) => {
	const history = useHistory()
	const { user, setUser, setResourceAuth, setMenuAuth, setRoleAuth } = useGlobalModel();

	useEffect(() => {
		// console.log(window.loginTimer);
		if (!window.loginTimer) {
			window.loginTimer = setTimeout(function () { beforeLogin() }, 1500);
		}
	}, [])

	const beforeLogin = async () => {
		let { retData, retMsg } = await loginServiceAuth2.VerifyInfo({ sourceApp: defaultMdCmParam.sourceApp, token });
		let { menus, resources, roles, shops, ...userInfo } = retData ?? {};

		setResourceAuth(resources ?? []);  //设置资源列表
		setRoleAuth(roles ?? []);   //设置用户角色
		//设置用户菜单所有权限列表,(递归查询到所有要展示得菜单地址。)
		let menuArr: string[] = [];
		function findMenuAll(array: Auth2MenuDetail[]) {
			array.forEach(item => {
				item.linkUrl && menuArr.push(item.linkUrl);
				if (item.children && item.children.length > 0)
					findMenuAll(item.children);
			})
		}
		findMenuAll(menus?.[CLIENT_APP_CODE] ?? []);
		setMenuAuth(menuArr);
		setUser({ ...user, ...userInfo, token, loginType: 'token' });
		history.push("/")
	}

	return (
		<div className="login">
			<div className="caseBlanche">
				<div className="rond">
					<div className="test"></div>
				</div>
				<div className="load">
					<p>loading</p>
				</div>
			</div>
		</div>
	)

}

export default TokenLogin;